import React from "react";
import { motion } from "framer-motion";
import { Container } from "../zen/Container";
import { Navbar } from "../layout/Navbar";

/**
 * ApplicationLayout — focused application surface (Navbar in quiet mode, no Footer).
 * - Navbar (quiet mode handled inside Navbar via route detection)
 * - NO Footer (intentional, prevents user drop-off mid-flow)
 * - Cinematic dark base + subtle drifting accent glow behind the card
 * - Centered card max-w-2xl on desktop, edge-bleed comfortable on mobile
 * - Renders children inside the centered card area
 */
export const ApplicationLayout = ({ children }) => {
    return (
        <div className="relative min-h-screen bg-base text-text-primary">
            <Navbar />

            {/* Background drifting glow */}
            <div className="pointer-events-none absolute inset-x-0 top-0 h-[80vh] overflow-hidden">
                <motion.div
                    aria-hidden
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 1.6, ease: "easeOut" }}
                    className="absolute left-1/2 top-1/2 h-[600px] w-[800px] -translate-x-1/2 -translate-y-1/2 rounded-full"
                    style={{
                        background:
                            "radial-gradient(ellipse at center, rgba(124,255,79,0.08) 0%, rgba(124,255,79,0.02) 30%, transparent 65%)",
                        filter: "blur(80px)",
                    }}
                />
                <motion.div
                    aria-hidden
                    animate={{ x: [0, 30, -20, 0], y: [0, -20, 20, 0] }}
                    transition={{
                        duration: 24,
                        repeat: Infinity,
                        ease: "easeInOut",
                    }}
                    className="absolute -left-20 top-40 h-[320px] w-[320px] rounded-full"
                    style={{
                        background: "rgba(124,255,79,0.04)",
                        filter: "blur(120px)",
                    }}
                />
                <div className="zen-grid opacity-50" />
            </div>

            <main className="relative z-10 pt-[88px]">
                <Container className="!px-4 sm:!px-6">
                    <div className="mx-auto w-full max-w-2xl pt-8 pb-40 sm:pt-14 sm:pb-24">
                        {children}
                    </div>
                </Container>
            </main>
        </div>
    );
};

export default ApplicationLayout;
